import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
	components: {
	},
})
export default class App extends Vue {
	get overlay() {
		return this.$store.getters.overlay
	}

	@Watch('store.getters.fullTime')
	refresh() {
		if (this.$store.getters.fullTime.every((i: Number) => i == 0)) {
			this.$router.push({ name: "Home" });
			this.$store.commit("clearStore");
		}
	}  
}
